<template>
<div class="modal drivers-delete">
  <div class="modal__wrapper">
    <div class="modal__close" @click="$emit('close-modal')">
      <fa-icon icon="times"></fa-icon>
    </div>
    <div class="modal__title">Chauffeur verwijderen</div>
    <div class="modal__body">
      <p>Ben je zeker dat je de chauffeur wenst te verwijderen?</p>
    </div>
    <div class="modal__controls">
      <button class="button button--cancel" @click="$emit('delete-decline')">Nee</button>
      <button class="button button--accept" @click="$emit('delete-confirm')">Ja</button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "DriversDelete"
}
</script>
